import React from 'react';
import './Appointments.scss';
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import moment from 'moment';
import { Appointment } from 'services/appointment/appointment.types';
import useAppointmentsVM from './useAppointmentsVM';
import { Modal } from 'components/Modal/Modal';
export const Appointments: React.FunctionComponent<{
    isLoading: boolean;
    data: Appointment[];
}> = ({ isLoading, data }) => {
    const {
        datalists,
        isAppointmentInfoModalOpen,
        setIsAppointmentInfoModalOpen,
        selectedAppointment,
        setSelectedAppointment,
        handleUpdateAppointment
    } = useAppointmentsVM();

    return (
        <>
            <ContentBlock isLoading={isLoading} title="Demandes de rendez-vous" className="appointments">
                {data.length > 0 ? (
                    <>
                        <div className="appointments-container">
                            {data.map((item) => (
                                <div
                                    className="appointment-item"
                                    key={'persons-appointments-' + item.id}
                                    onClick={() => {
                                        setSelectedAppointment(item);
                                        setIsAppointmentInfoModalOpen(true);
                                    }}
                                >
                                    <div className="appointment">
                                        <div className="day">
                                            <span className="number">{moment(item.started_at).format('DD')}</span>
                                            <span className="month">{moment(item.started_at).format('MMM')}</span>
                                        </div>
                                        <div className="hours">
                                            <div className="start">{moment(item.started_at).format('HH:mm')}</div>
                                            <div className="end">{moment(item.ended_at).format('HH:mm')}</div>
                                        </div>
                                        <div className="separator"></div>
                                        <div className="description">
                                            <span className="nature">{item.label}</span>
                                            <span className="person">Demandé par {item.person}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <div className="no-appointment">Aucune demande de rendez-vous</div>
                )}
            </ContentBlock>

            <Modal
                open={isAppointmentInfoModalOpen}
                setClose={() => setIsAppointmentInfoModalOpen(false)}
                title="Informations sur le rendez-vous"
                yesText="Accepter"
                noText="Refuser"
                onClose={() => handleUpdateAppointment('refused')}
                onValidate={() => {
                    console.log('test');
                    handleUpdateAppointment('accepted');
                    setSelectedAppointment(undefined);
                    setIsAppointmentInfoModalOpen(false);
                }}
                closeOnValidate={false}
            >
                <p>Demandé par {selectedAppointment?.person}</p>
                <p>Nom du rendez-vous : {selectedAppointment?.label}</p>
                <p>Commentaire : {selectedAppointment?.observation}</p>
                <p>Type de communication : {datalists?.communication_types?.[selectedAppointment?.communication_type ?? ''] ?? ''}</p>
                <p>Début : {moment(selectedAppointment?.started_at).format('DD/MM/YYYY HH:mm')}</p>
                <p>Fin : {moment(selectedAppointment?.ended_at).format('DD/MM/YYYY HH:mm')}</p>
            </Modal>
        </>
    );
};
